import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <polygon
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="50,5 11,27 11,72 50,95 89,73 89,28"
        fill="none"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        fontSize="40"
        fontFamily="Arial, Helvetica, sans-serif"
        fill="currentColor"
        dy=".3em">
        M
      </text>
    </g>
  </svg>
);

export default IconLoader;
